import getSpaceRadius from './getSpaceRadius'

const findMapObjectByCoordinates = (
  mouse,
  { touchScreen, dx, dy, spaces, pins, devices, xScale, yScale, rScale, zoomScale, transform: t }
) => {
  const dr = zoomScale(t.k)
  const mx = mouse[0] - dx * t.k
  const my = mouse[1] - dy * t.k

  for (let i = 0; i < spaces.ids.length; i++) {
    const space = spaces.byId[spaces.ids[i]]
    let radius = getSpaceRadius({ space, k: t.k, rScale })

    // Increase tap radius for map objects on touch devices
    if (touchScreen) {
      radius *= 2
    }

    const r = 1.1 * radius
    const x = xScale(space.x)
    const y = yScale(space.y)

    if (mx >= x - r && mx <= x + r && my >= y - r && my <= y + r) {
      return space
    }
  }

  if (pins) {
    for (let i = 0; i < pins.ids.length; i++) {
      const pin = pins.byId[pins.ids[i]]
      let r = (1.5 * pin.map.w) / 2
      const x = xScale(pin.map.x)
      const y = yScale(pin.map.y)

      r *= (rScale(r) / r) * dr

      if (mx >= x - r && mx <= x + r && my >= y - r && my <= y + r) {
        return pin
      }
    }
  }

  if (devices) {
    for (let i = 0; i < devices.ids.length; i++) {
      const device = devices.byId[devices.ids[i]]
      let r = (1.5 * device.map.w) / 2
      const x = xScale(device.map.x)
      const y = yScale(device.map.y)

      r *= (rScale(r) / r) * dr

      if (mx >= x - r && mx <= x + r && my >= y - r && my <= y + r) {
        return device
      }
    }
  }

  return null
}

export default findMapObjectByCoordinates
